/**
 * HoM Auto-Proceed Checkout — on product pages, when URL contains
 * ?auto-proceed=true, show a full-screen loader, clear the cart, add the
 * current variant (with selling plan + referral properties if present)
 * directly via /cart/add.js, then redirect to /checkout.
 *
 * Mirrors the existing "Buy Now" flow in blocks/buy-buttons.liquid so it
 * works on subscription / selling-plan products.
 *
 * Fails open: 30s safety timer or any error removes the overlay silently.
 */
(function () {
    'use strict';

    var PRODUCT_PATH_RE = /^\/products\/[^\/]+\/?$/;
    var TIMEOUT_MS = 30000;
    var OVERLAY_ID = 'hom-auto-proceed-overlay';

    if (!PRODUCT_PATH_RE.test(window.location.pathname)) return;

    var params = new URLSearchParams(window.location.search);
    if (params.get('auto-proceed') !== 'true') return;

    var form = document.querySelector('form[action*="/cart/add"]');
    var variantInput = form && form.querySelector('input[name="id"]');
    var variantId = variantInput && variantInput.value;
    if (!variantId) return;

    var overlay = buildOverlay();
    document.body.appendChild(overlay);

    var done = false;
    var timer = setTimeout(function () {
        if (done) return;
        done = true;
        removeOverlay();
    }, TIMEOUT_MS);

    var referralCode = params.get('ref') || params.get('referral') || params.get('code') || params.get('affiliate');
    var offerCode = params.get('offer');

    resolveSellingPlan(form, variantId).then(function (sellingPlanId) {
        if (done) return;

        var cartPayload = {
            id: variantId,
            quantity: 1,
            properties: {}
        };
        if (sellingPlanId) cartPayload.selling_plan = sellingPlanId;
        if (referralCode) {
            cartPayload.properties._referral_code = referralCode;
            cartPayload.properties.Referral = referralCode;
        }

        return fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin'
        }).then(function () {
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(cartPayload),
                credentials: 'same-origin'
            });
        });
    })
        .then(function (response) {
            if (done) return;
            if (!response.ok) {
                done = true;
                clearTimeout(timer);
                removeOverlay();
                return;
            }
            done = true;
            clearTimeout(timer);
            var checkoutParams = [];
            if (referralCode) {
                checkoutParams.push('ref=' + encodeURIComponent(referralCode));
            }
            if (offerCode) {
                checkoutParams.push('discount=' + encodeURIComponent(offerCode));
            }
            var checkoutUrl = '/checkout';
            if (checkoutParams.length) {
                checkoutUrl += '?' + checkoutParams.join('&');
            }
            window.location.href = checkoutUrl;
        })
        .catch(function () {
            if (done) return;
            done = true;
            clearTimeout(timer);
            removeOverlay();
        });

    function readSellingPlanFromForm(form) {
        if (!form) return null;
        var radio = form.querySelector('input[name="selling_plan"]:checked');
        if (radio && radio.value) return radio.value;
        var select = form.querySelector('select[name="selling_plan"]');
        if (select && select.value) return select.value;
        var hidden = form.querySelector('input[name="selling_plan"][type="hidden"]');
        if (hidden && hidden.value) return hidden.value;
        return null;
    }

    function resolveSellingPlan(form, variantId) {
        var fromForm = readSellingPlanFromForm(form);
        if (fromForm) return Promise.resolve(fromForm);

        var handleMatch = window.location.pathname.match(/^\/products\/([^\/]+)\/?$/);
        if (!handleMatch) return Promise.resolve(null);

        return fetch('/products/' + handleMatch[1] + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (product) {
                if (!product || !product.variants) return null;
                var variant = product.variants.find(function (v) {
                    return String(v.id) === String(variantId);
                });
                var allocs = variant && variant.selling_plan_allocations;
                if (allocs && allocs.length && allocs[0].selling_plan_id) {
                    return String(allocs[0].selling_plan_id);
                }
                return null;
            })
            .catch(function () { return null; });
    }

    function buildOverlay() {
        var el = document.createElement('div');
        el.id = OVERLAY_ID;
        el.setAttribute('role', 'status');
        el.setAttribute('aria-busy', 'true');
        el.setAttribute('aria-live', 'polite');
        el.style.cssText = [
            'position:fixed',
            'inset:0',
            'background:rgba(0,0,0,0.55)',
            'z-index:2147483647',
            'display:flex',
            'align-items:center',
            'justify-content:center',
            'flex-direction:column',
            'gap:16px'
        ].join(';');

        var spinner = document.createElement('div');
        spinner.style.cssText = [
            'width:48px',
            'height:48px',
            'border:4px solid rgba(255,255,255,0.25)',
            'border-top-color:#fff',
            'border-radius:50%',
            'animation:hom-auto-proceed-spin 0.9s linear infinite'
        ].join(';');

        var label = document.createElement('div');
        label.textContent = 'Proceeding to checkout…';
        label.style.cssText = [
            'color:#fff',
            'font-family:inherit',
            'font-size:14px',
            'letter-spacing:0.02em'
        ].join(';');

        var style = document.createElement('style');
        style.textContent = '@keyframes hom-auto-proceed-spin{to{transform:rotate(360deg)}}';

        el.appendChild(style);
        el.appendChild(spinner);
        el.appendChild(label);
        return el;
    }

    function removeOverlay() {
        var el = document.getElementById(OVERLAY_ID);
        if (el && el.parentNode) el.parentNode.removeChild(el);
    }
})();
